function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "content"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 7302",
    d: "M2 5.5V7.5C2 9.14992 2 9.97487 2.51256 10.4874C3.02513 11 3.85008 11 5.5 11H6.5C8.14992 11 8.97487 11 9.48744 10.4874C10 9.97487 10 9.14992 10 7.5V5.5",
    stroke: "#344054",
    style: {
      stroke: "#344054",
      stroke: "color(display-p3 0.2053 0.2525 0.3280)",
      strokeOpacity: 1
    },
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1184",
    d: "M1.5 4.5C1.5 4.12615 1.5 3.93923 1.60048 3.8C1.66631 3.70879 1.76099 3.63305 1.875 3.58038C2.04904 3.5 2.28269 3.5 2.75 3.5H9.25C9.71731 3.5 9.95096 3.5 10.125 3.58038C10.239 3.63305 10.3337 3.70879 10.3995 3.8C10.5 3.93923 10.5 4.12615 10.5 4.5C10.5 4.87385 10.5 5.06077 10.3995 5.2C10.3337 5.29121 10.239 5.36695 10.125 5.41962C9.95096 5.5 9.71731 5.5 9.25 5.5H2.75C2.28269 5.5 2.04904 5.5 1.875 5.41962C1.76099 5.36695 1.66631 5.29121 1.60048 5.2C1.5 5.06077 1.5 4.87385 1.5 4.5Z",
    stroke: "#344054",
    style: {
      stroke: "#344054",
      stroke: "color(display-p3 0.2053 0.2525 0.3280)",
      strokeOpacity: 1
    },
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2365",
    d: "M3 1.89286C3 1.39975 3.39975 1 3.89286 1H4.07143C5.13655 1 6 1.86345 6 2.92857V3.5H4.60714C3.71954 3.5 3 2.78046 3 1.89286Z",
    stroke: "#344054",
    style: {
      stroke: "#344054",
      stroke: "color(display-p3 0.2053 0.2525 0.3280)",
      strokeOpacity: 1
    },
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2366",
    d: "M9 1.89286C9 1.39975 8.60025 1 8.10714 1H7.92857C6.86345 1 6 1.86345 6 2.92857V3.5H7.39286C8.28046 3.5 9 2.78046 9 1.89286Z",
    stroke: "#344054",
    style: {
      stroke: "#344054",
      stroke: "color(display-p3 0.2053 0.2525 0.3280)",
      strokeOpacity: 1
    },
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 4639",
    d: "M6 5.5L6 11",
    stroke: "#344054",
    style: {
      stroke: "#344054",
      stroke: "color(display-p3 0.2053 0.2525 0.3280)",
      strokeOpacity: 1
    },
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.00d5b702b0b30b2b3b7ead5d1e9da5c1.svg";
export { ForwardRef as ReactComponent };